<script>
	import Button from '$lib/Components/Layout/Button/Button.svelte';
	import Image from '$lib/Components/Layout/Image/Image.svelte';
	import Section from '$lib/Components/Layout/Section/Section.svelte';
	import Parallax from '$lib/Components/Parallax/Parallax.svelte';

	import tapeMeasure from './images/LP-Self-Measure-Tape-Measurement-Form-01.png';
	import tapeMeasureform from './images/LP-Self-Measure-Tape-Measurement-Form-02.jpg';
	import tapeMeasureImg from './images/LP-Self-Measure-Tape-Measurement-Form-03.jpg';
</script>

<Section backgroundColor="blue" class="pb-0">
	<h2>Self Measure Form</h2>
	<Image src={tapeMeasure} alt="" class="w-full" />
</Section>

<Section>
	<h3>4 Steps to a Comfortable Space</h3>
	<ol class="list-decimal">
		<li><p>Record your measurements here.</p></li>
		<li>
			<p>
				When finished measuring, use the emailed link to access <strong
					>Measure by Indow®</strong
				>
				portal
			</p>
			<ul>
				<li>
					<p>
						Check your email for a subject line containing “Measure by Indow”
					</p>
				</li>
				<li>
					<p>
						If you cannot find or access your Measure by Indow portal, please
						fill out <a href="/self-measure-instructions#measure-support-form"
							>this form.</a
						>
					</p>
				</li>
				<li>
					<p>
						If you need further assistance, schedule a <a
							href="/measure-support">Measure Support call</a
						>
					</p>
				</li>
			</ul>
		</li>
		<li><p>Enter your recorded dimensions into the portal.</p></li>
		<li>
			<p>
				Keep this sheet until AFTER your inserts are installed & fit is tested.
			</p>
		</li>
	</ol>
	<p>
		A comfortable space is only 4 steps away. We’re here to help at every step:
		503.284.2260.
	</p>
</Section>

<Section>
	<h2>Get Measuring!</h2>
	<p>
		Record values here and retain this document for your records until you have
		installed your inserts and verify they fit properly.
	</p>
	<Image src={tapeMeasureform} alt="" class="w-full" />
	<Button
		href="https://indowwindows.com/static/pdfs/Self_Measure_Form-FOR-TAPE-MEASURE-10-13-21-1.pdf"
		>Download Form</Button
	>
</Section>

<Parallax image={tapeMeasureImg} />
